<template>
    <div class="details">
        <div class="detailsBox">
            <div class="back" @click="backBtn">&lt;&nbsp;{{ $t('meg.back') }}</div>
            <h1 v-if="roleType == 2" style="font-size: .2rem;">{{ $t('meg.hzy') }}</h1>
            <div class="infor">{{ $t('meg.Ordering') }}</div>
            <div class="formBox">
                <div class="liBox" v-if="roleType != 2">
                    <li>
                        <span>{{ $t('meg.CustomerName') }}:</span>
                        <span>{{ detailsData.companyName }}</span>
                    </li>
                    <li>
                        <span>{{ $t('meg.contacts') }}:</span>
                        <span>{{ detailsData.contacts }}</span>
                    </li>
                    <li>
                        <span>{{ $t('meg.contactsInformation') }}:</span>
                        <span>{{ detailsData.phonenumber }}</span>
                    </li>
                    <li style="margin-right: 1.1875rem;">
                        <span>{{ $t('meg.CustomerType') }}:</span>
                        <span>{{ detailsData.clientType }}</span>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;" v-if="roleType != 2">
                    <li>
                        <span>{{ $t('meg.ordertt') }}:</span>
                        <span>{{ detailsData.orderType }}</span>
                    </li>
                    <li style="margin-left: -0.5rem;">
                        <span>{{ $t('meg.productiontype') }}:</span>
                        <span>{{ detailsData.productType }}</span>
                    </li>
                    <li>
                        <span>{{ $t('meg.producttype') }}:</span>
                        <span>{{ detailsData.productMold }}</span>
                    </li>
                    <li style="margin-right: 1.1875rem;">
                        <span>{{ $t('meg.processtype') }}:</span>
                        <span>{{ detailsData.processType }}</span>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;gap: 2.45rem;justify-content: flex-start;">
                    <li>
                        <span>{{ $t('meg.pictures') }}:</span>
                        <span @click="viewImage()"
                            style="text-decoration: underline;color: blue;text-decoration: underline;cursor: pointer;">查看</span>
                        <el-image-viewer @close="closePreview" class="pre-box" v-if="showImagePreview" ref="preview" :url-list="imageList"  fit="cover" style="display: none;" />
                    </li>
                    <li style="margin-left:.2rem" v-if="roleType != 2">
                        <span>{{ $t('meg.preparation') }}:</span>
                        <a :href="detailsData.prepareDocument" target="_blank"
                            style="text-decoration: underline;color: blue;">{{ $t('meg.view') }}</a>
                    </li>
                    <li style="margin-left:.2rem" v-if="roleType == 2">
                        <span>{{ $t('meg.preparation') }}:</span>
                        <a :href="documentationListUrl" target="_blank"
                            style="text-decoration: underline;color: blue;">{{ $t('meg.view') }}</a>
                    </li>
                    <li style="margin-left: 42px;" v-if="roleType == 1 && type == 1">
                        <span>{{ $t('meg.contract') }}:</span>
                        <a :href="detailsData.clientContract" target="_blank"
                            style="text-decoration: underline;color: blue;">{{ $t('meg.view') }}</a>
                    </li>
                    <li style="margin-left: 42px;" v-if="roleType == 2 && type == 1">
                        <span>{{ $t('meg.contract') }}:</span>
                        <a :href="detailsData.plantContract" target="_blank"
                            style="text-decoration: underline;color: blue;">{{ $t('meg.view') }}</a>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;justify-content: flex-start;">
                    <li>
                        <span>{{ $t('meg.total') }}:</span>
                        <span>{{ type == 2 ? sunNum : detailsData.sum }}</span>
                    </li>
                    <li style="margin-left: .375rem;">
                        <span>{{ $t('meg.productName') }}:</span>
                        <span>{{  detailsData.productName }}</span>
                    </li>

                </div>
                <hr style="margin-top: .3625rem;border: .0125rem solid #DDD;width: 10.1125rem;" />
                <!-- 表格 -->
                <div style="margin-top:.25rem;margin-bottom: .25rem;">
                    <tr class="tr">
                        <td class="td"></td>
                        <td class="td" style="font-weight: 700;" v-for="(i, ci) in productTable.sizeList">
                            {{ i.sizeNumber }}
                        </td>
                        <td class="td" style="font-weight: 700;">{{ $t('meg.totals') }}</td>
                    </tr>
                    <tr class="tr2" v-for="(s, dex) in productTable.colorList" :key="dex">
                        <td class="td">{{ s.color }}</td>
                        <td class="td" v-for="(e, ind) in s.skulists" :key="ind">
                            {{ e.number }}
                        </td>
                        <td class="td">
                            {{ calculateSum(s.skulists) }}
                        </td>
                    </tr>
                </div>
                <div class="infor" style="margin-left: 0;">{{ $t('meg.DeliveryInfo') }}</div>
                <div class="liBox" style="margin-top: .625rem;">
                    <li>
                        <span>{{ $t('meg.arrivaltime') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.materialTime : detailsData.materialTime }}</span>
                    </li>
                    <li>
                        <span>{{ $t('meg.deliveryType') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.deliveryType : detailsData.deliveryType }}</span>
                    </li>
                    <li>
                        <span>{{ $t('meg.shippingtime') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.shipmentTime : detailsData.shipmentTime }}</span>
                    </li>
                    <li style="margin-right: 1.1875rem;">
                        <span>{{ $t('meg.destination') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.shipmentDestination : detailsData.shipmentDestination }}</span>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;">
                    <li>
                        <span>{{ $t('meg.Payment') }}:</span>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;">
                    <li>
                        <span>{{ $t('meg.advance') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.advancePayment : detailsData.advancePayment }}</span>
                    </li>
                    <li>
                        <span>{{ $t('meg.shipment') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.disbursementFunds : detailsData.disbursementFunds }}</span>
                    </li>
                    <li>
                        <span>{{ $t('meg.balance') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.finalPayment : detailsData.finalPayment }}</span>
                    </li>
                    <li style="margin-right: 1.1875rem;">
                        <span>{{ $t('meg.period') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.affiliatingArea : detailsData.affiliatingArea }}</span>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;">
                    <li>
                        <span>{{ $t('meg.points') }}:</span>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;gap:2.6875rem;justify-content: start;">
                    <li>
                        <span>{{ $t('meg.general') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.generalTaxPoint : detailsData.generalTaxPoint }}</span>
                    </li>
                    <li>
                        <span>{{ $t('meg.special') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.dedicatedTaxPoint : detailsData.dedicatedTaxPoint }}</span>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;gap:2.6875rem;justify-content: start;">
                    <li>
                        <span>{{ $t('meg.settlement') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.meansPayments : detailsData.meansPayments }}</span>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;gap:2.6875rem;justify-content: start;">
                    <li>
                        <span>{{ $t('meg.shipping') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.shippingMethod : detailsData.shippingMethod }}</span>
                    </li>
                </div>
                <div class="liBox" style="margin-top: .625rem;gap:2.6875rem;justify-content: start;">
                    <li>
                        <span>{{ $t('meg.price') }}:</span>
                        <span>{{ type == 2 ? deliveryManage.intendedTargetPrice : detailsData.intendedTargetPrice }}</span>
                    </li>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import { clientProductExhibition,plantProductExhibition } from "@/api/order.js"
import { onMounted, reactive, ref,defineComponent } from 'vue';
import { getDetailsData } from "@/api/person.js"

const router = useRouter()
const route = useRoute()
const orderId = ref("")
const devlieryId = ref("")
const type = ref("")
const preview = ref(null)
const imgUrl = ref("")
const roleType = ref("")
const detailsData = ref({})
const productTable = ref([])
const deliveryManage = ref([])
const imageList = ref([])
const sunNum = ref("")
const documentationListUrl = ref("")
const showImagePreview = ref(false)
onMounted(() => {
    orderId.value = route.query.orderId
    devlieryId.value = route.query.devlieryId
    type.value = route.query.type
    roleType.value = route.query.roleType
    getDetails()
})

const backBtn = () => {
    router.go(-1)
}
const getDetails = () => {
    if (type.value == 2) {
        let obj = {
            id: devlieryId.value,
            type: type.value
        }
        getDetailsData(obj).then(res => {
            sunNum.value = res.data.data.sum
            imageList.value = []
            res.data.data.pictures.forEach(item => {
                    // imgUrl.value = item.url
                    imageList.value.push(item.url)
                })
            detailsData.value = res.data.data.letterIntent
            deliveryManage.value = res.data.data.deliveryManage
            productTable.value = res.data.data.productDatailVos[0]
        })
    } else {
       if(roleType.value == 1) {
        let obj = {
            orderId: orderId.value,
            type: roleType.value
        }
        clientProductExhibition(obj).then(res => {
            if (res.data.code == 200) {
                detailsData.value = res.data.data
                imageList.value = []
                res.data.data.pictures.forEach(item => {
                    // imgUrl.value = item.url
                    imageList.value.push(item.url)
                })
                productTable.value = res.data.data.productDatailVos[0]
            }
        })
       } else if(roleType.value == 2){
        plantProductExhibition(orderId.value).then(res => {
            if (res.data.code == 200) {
                detailsData.value = res.data.data
                imageList.value = []
                res.data.data.pictures.forEach(item => {
                    // imgUrl.value = item.url
                    imageList.value.push(item.url)
                })
                productTable.value = res.data.data.productDatailVos[0]
                documentationListUrl.value = res.data.data.documentationList[0].url
            }
        })
       }
    }
}
const closePreview = () =>{
    showImagePreview.value = false
}
const viewImage = () => {
    showImagePreview.value = true
}
// 在 setup 中创建计算总和的函数
const calculateSum = (skulists) => {
    // 遍历 skulists 中的每个元素的 number 属性并将其相加
    let sum = 0;
    skulists.forEach((e) => {
        sum += parseFloat(e.number); // 转换为数字并相加
    });
    return sum; // 返回总和
};
</script>

<style scoped>
.details {
    background: #F8F8F8;
    overflow: hidden;
}

.detailsBox {
    /* height: 1812px; */
    padding-bottom: .625rem;
    margin-bottom: .375rem;
    background: #FFFFFF;
    /* border-radius: 0px 0px 0px 0px; */
    opacity: 1;
    margin-left: 3.25rem;
    margin-right: 3.25rem;
    margin-top: 1.275rem;
    overflow: hidden;
}

.back {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: left;
    margin-left: .425rem;
    margin-top: .3rem;
    cursor: pointer;
}

.infor {
    height: .6375rem;
    background: #EEEEEE;
    /* border-radius: 0px 0px 0px 0px; */
    opacity: 1;
    margin-left: .35rem;
    margin-right: .35rem;
    margin-top: .2625rem;
    line-height: .6375rem;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 700;
    color: #000000;
    text-align: left;
    padding-left: .25rem;
}

.formBox {
    margin-top: .3rem;
    text-align: left;
    margin-left: .425rem;
}

.liBox {
    display: flex;
    justify-content: space-between;
}

.liBox li {
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
}

.liBox li span:nth-child(2) {
    margin-left: .1875rem;
}

.tr {
    width: auto;
    height: .625rem;
    background: #EEEEEE;
    font-size: .2rem;
}

.tr2 {
    width: auto;
    height: .625rem;
    border-bottom: .0125rem solid #DDDDDD;
    font-size: .2rem;
}

.td {
    width: 2.5rem;
    height: .625rem;
    text-align: center;
    vertical-align: middle;
    font-size: .2rem;
    /* border: solid 1px #f0f2f5; */
}

.tr3 {
    /* // width: 500px; */
    height: .625rem;
    font-size: .2rem;
}

.td3 {
    margin-top: .25rem;
    margin-bottom: .25rem;
    margin-left: .625rem;
    font-size: .2rem;
}
</style>
